"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Heal;

var _Heal = require("@adobe/react-spectrum-workflow/dist/Heal.js");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Heal(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Heal.A4uHeal, null));
}